var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mapType[_vm.type],_vm._b({tag:"component",attrs:{"disabled":_vm.disabled}},'component',_vm.componentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }